// extracted by mini-css-extract-plugin
export default {"container":"get_channel_ad_container__WRD2s","text":"get_channel_ad_text__rH+MA"};